import 'bootstrap5-toggle';

import { topMenu, showMenu, getQueryStrings, getExperiments, updateURLs, getExtremeDates } from './main';
import * as utils from '../utils';

import { plotHeatmap } from '../components/charts/heatmap';
import { initGauges, plotGauges } from '../components/charts/gauges';
import { plotStatisticsTimeSeries } from '../components/charts/time-series-statistics';
import { getMapData, getHeatmapData, getForecastData, getStatisticsTimeSeriesData, getFairmodeData } from '../components/io';
import { plotMiniMap } from '../components/charts/mini-map';
import { plotTaylor } from '../components/charts/taylor';
import { initTargets, plotTargetCircle, plotTargetBars } from '../components/charts/targets';
import { plotForecast } from '../components/charts/time-series-forecast';
import { getCookie, setCookie } from '../components/cookies';
//import * as chatbot from '../components/chatbot'
import { initSoundBox } from '../components/sound-box'

/*import interfaces*/
import { Aeroval } from '../types/global';

// Extend the Globals interface
interface ExtendedGlobals extends Aeroval {
	sound: boolean;
	play: boolean;
	hide: string[];
	tabsMenuButtons: {
		[key: string]: Aeroval['menuButtons'];
	};
	soundBox: any;
	genres: string[];
	genre: string;
	annotations: boolean;
}
declare var aeroval: ExtendedGlobals;


document.addEventListener('DOMContentLoaded', () => {
	if (window.location.pathname.includes('pages/overall')) {
		init();
	}
});

function init(): void {
	console.log('initialize overall page');
	utils.initAPI();

	// set some defaults
	aeroval.axisType = 'linear'; //"logarithmic" //"linear"
	aeroval.frequency = 'monthly';
	aeroval.hide = [];
	aeroval.tab = 'heatmap';
	aeroval.sound = false;
	aeroval.play = false;
	aeroval.seriesVisibility = {};
	aeroval.tabsMenuButtons = {
		heatmap: ['obsType', 'region', 'time', 'statistic'],
		taylor: ['parameter', 'observation', 'region', 'time'],
		timeseries: ['parameter', 'observation', 'region', 'yearAndGroupBy', 'meanAndStatistic'],
		target: ['parameter', 'observation', 'model', 'region', 'time-no_freqs'],
		median: ['parameter', 'observation', 'region', 'time', 'statistic'],
	};

	//check if any queries
	getQueryStrings();

	makeDivs();
	aeroval.menuButtons = aeroval.tabsMenuButtons[aeroval.tab];
	// experiments
	getExperiments(true, false, true, true, true);
	//update header links with qs project
	updateURLs('project', aeroval.project);
	// initialize gauges
	initGauges('gauges')

	// start chatbot
	//chatbot.start()


	if (aeroval.sound) {
		initSoundBox()
	}

	// Set up actions on tab change
	document.querySelectorAll('button[data-bs-toggle="tab"]').forEach((tabButton) => {
		tabButton.addEventListener('shown.bs.tab', (e: Event) => {
			const target = e.target as HTMLElement;
			const tabId = target.id.split('-')[1];
			aeroval.tab = tabId;
			// delete aeroval zoom
			delete aeroval.zoom;
			// update header urls
			updateURLs('tab', aeroval.tab);
			utils.updateQueryString('tab', aeroval.tab)
			makeDivs();
			aeroval.menuButtons = aeroval.tabsMenuButtons[aeroval.tab];
			getExperiments(true, false, true, true, true);
		});
	});

	// Show active tab
	const tabs = Object.keys(aeroval.tabsMenuButtons);
	const isTabInTabs = tabs.includes(aeroval.tab)
	const selectedTab = isTabInTabs ? aeroval.tab : tabs[0]

	tabs.forEach((tab) => {
		const tabButton = document.querySelector(`#nav-${tab}-tab`);
		const tabContent = document.querySelector(`#nav-${tab}`);
		if (tabButton && tabContent) {
			if (tab === selectedTab) {
				tabButton.classList.add('active');
				tabContent.classList.add('show', 'active');
				aeroval.tab = selectedTab;
				utils.updateQueryString('tab', selectedTab)
			} else {
				tabButton.classList.remove('active');
				tabContent.classList.remove('show', 'active');
			}
		}
	});

}

function updateAxisType(div: string): void {
	document.body.style.cursor = 'progress';
	const chart = utils.getChartById(div);
	if (!chart) return;

	if (aeroval.axisType == 'linear') {
		chart.xAxis[0].update(
			{
				softMin: 0,
				type: aeroval.axisType,
			},
			false
		);
		chart.yAxis[0].update(
			{
				softMin: 0,
				type: aeroval.axisType,
			},
			false
		);
	} else if (aeroval.axisType == 'logarithmic') {
		chart.xAxis[0].update(
			{
				type: aeroval.axisType,
			},
			false
		);
		chart.yAxis[0].update(
			{
				type: aeroval.axisType,
			},
			false
		);
	}
	chart.redraw();

	document.body.style.cursor = 'default';
}

export async function callbackMenu() {
	if (!aeroval.region) return;
	if (aeroval.tab === 'heatmap') {
		document.getElementById('gauges')!.style.display = 'block';
		document.getElementById('minimap')!.style.display = 'none';
		const hmData = await getHeatmapData(aeroval.project, aeroval.experiment.name, aeroval.frequency, aeroval.region, aeroval.time, aeroval.season)
		if (hmData) plotHeatmap(hmData, 'heatmap'); plotGauges()
	} else if (aeroval.tab === 'taylor' || aeroval.tab === 'timeseries' || aeroval.tab === 'target' || aeroval.tab === 'median') {
		document.getElementById('gauges')!.style.display = 'none';
		document.getElementById('minimap')!.style.display = 'block';
		if (aeroval.tab === 'taylor') {
			const hmData = await getHeatmapData(aeroval.project, aeroval.experiment.name, aeroval.frequency, aeroval.region, aeroval.time, aeroval.season)
			if (hmData) plotTaylor(hmData, 'tlrdgrm')
			const mapData = await getMapData(aeroval.project, aeroval.experiment.name, aeroval.observation, aeroval.parameter.dir, aeroval.layer, aeroval.model.dir, aeroval.model.var, aeroval.time, aeroval.season, aeroval.frequency)
			if (mapData) plotMiniMap(mapData);
		} else if (aeroval.tab === 'timeseries') {
			const statsTsData = await getStatisticsTimeSeriesData(aeroval.project, aeroval.experiment.name, aeroval.region, aeroval.observation, aeroval.parameter.dir, aeroval.layer)
			if (statsTsData) plotStatisticsTimeSeries(statsTsData, aeroval.parameter.dir, aeroval.observation, aeroval.layer, aeroval.statistic.dir, aeroval.groupBy, 'overall-ts');
			getExtremeDates(true);
			const mapData = await getMapData(aeroval.project, aeroval.experiment.name, aeroval.observation, aeroval.parameter.dir, aeroval.layer, aeroval.model.dir, aeroval.model.var, aeroval.time, aeroval.season, aeroval.frequency)
			if (mapData) plotMiniMap(mapData);
		} else {
			if (aeroval.tab == 'target') {
				const mapData = await getMapData(aeroval.project, aeroval.experiment.name, aeroval.observation, aeroval.parameter.dir, aeroval.layer, aeroval.model.dir, aeroval.model.var, aeroval.time, aeroval.season, aeroval.frequency)
				if (!mapData) return
				plotMiniMap(mapData);
				const fairmodeData = await getFairmodeData(aeroval.project, aeroval.experiment.name, aeroval.region, aeroval.observation, aeroval.parameter.dir, aeroval.layer, aeroval.model.dir, aeroval.time)
				plotTargetCircle(fairmodeData, aeroval.observation, aeroval.parameter.dir, aeroval.model.dir, aeroval.layer, 'target', {});
				plotTargetBars(fairmodeData, aeroval.observation, aeroval.parameter.dir, aeroval.model.dir, aeroval.layer, 'target')
			} else if (aeroval.tab == 'median') {
				const forecastData = await getForecastData(aeroval.project, aeroval.experiment.name, aeroval.region, aeroval.observation, aeroval.parameter.dir, aeroval.layer)
				if (forecastData) plotForecast(forecastData, aeroval.parameter.dir, aeroval.observation, aeroval.layer, aeroval.statistic.dir, 'frcst-ts');
			}
		}
	}
}

export async function update(which: string, what: any): Promise<void> {
	console.log('update ', which, 'with ', what);
	if (which == 'meanAndStatistic' || which == 'statistic' || which == 'forecast_statistic') {
		aeroval.statistic = aeroval.statistics[what];
		aeroval.statistic.dir = what;
		if (what == 'data_mean') {
			aeroval.statistic.name = 'Mean';
			aeroval.statistic.longname = 'Mean (Obs and Model)';
		}
		topMenu();
		utils.updateQueryString('statistic', what);
		updateURLs('statistic', what);
	}
	if (which == 'region') {
		aeroval[which] = what;
		topMenu();
		utils.updateQueryString(which, what);
		updateURLs(which, what);
	}
	if (which == 'experiment') {
		aeroval.experiment = aeroval.experiments[what];
		aeroval.experiment.name = what;
		getExperiments(true);
		utils.updateQueryString(which, what);
		updateURLs(which, what);
	}
	if (which == 'obsType') {
		aeroval[which] = what;
		topMenu();
	}
	if (which == 'frequency') {
		aeroval[which] = what;
		topMenu();
		utils.updateQueryString(which, what);
		updateURLs(which, what);
	}
	if (which == 'axisType') {
		aeroval[which] = what;
		updateAxisType('scatt');
	}
	if (which == 'time' || which == 'time-no_freqs') {
		aeroval.time = what;
		topMenu();
		getExtremeDates();
		utils.updateQueryString('time', what);
		updateURLs(which, what);
	}
	if (which.includes('year')) {
		aeroval.time = what;
		showMenu(which, what);
		getExtremeDates();
		updateTimeSeries();
		utils.updateQueryString('time', what);
		updateURLs('time', what);
	}
	if (which == 'groupBy') {
		aeroval[which] = what;
		const region = aeroval.region as string;
		const statsTsData = await getStatisticsTimeSeriesData(aeroval.project, aeroval.experiment.name, region, aeroval.observation, aeroval.parameter.dir, aeroval.layer)
		if (statsTsData) plotStatisticsTimeSeries(statsTsData, aeroval.parameter.dir, aeroval.observation, aeroval.layer, aeroval.statistic.dir, aeroval.groupBy, 'overall-ts');
	}
	if (which == 'season') {
		aeroval[which] = what;
		topMenu();
		utils.updateQueryString(which, what);
		updateURLs(which, what);
	}
	if (which == 'parameter') {
		aeroval.parameter.dir = what;
		topMenu();
		utils.updateQueryString('parameter', what);
		updateURLs('parameter', what);
	}
	if (which == 'observation') {
		aeroval.observation = what;
		topMenu();
		utils.updateQueryString(which, what);
		updateURLs(which, what);
	}
	if (which == 'model') {
		aeroval.model = {
			name: what,
			dir: what,
			var: aeroval.modVars[what]
		}
		topMenu();
		utils.updateQueryString(which, what);
		updateURLs(which, what);
	}
}

function hideScat() {
	document.querySelector('#heatmap')?.classList.remove('col-md-7');
	document.querySelector('#heatmap')?.classList.add('col-md-12');
	const scatterPlot = document.querySelector('#scatterplot');
	if (scatterPlot instanceof HTMLElement) {
		scatterPlot.style.display = 'none';
	}
	if (aeroval.data.hm) {
		plotHeatmap(aeroval.data.hm, 'heatmap');
	}
}

async function makeDivs() {
	if (aeroval.tab == 'heatmap') {
		// first, empty the other tabs
		for (const tab of ['nav-timeseries', 'nav-taylor', 'nav-target', 'nav-median']) {
			const tabElement = document.getElementById(tab);
			if (tabElement) {
				tabElement.innerHTML = '';
			}
		}

		// then, creates the divs
		var h = "<div id='menu'></div>";
		h += "<div id='main-content'>";
		h += "<div class='row h-100' style='width: 100%; margin: 10px 0px; padding: 0px;'>";
		h += "<div id='heatmap' style='padding: 0;' class='col-md-12 col-sm-12 col-12'></div>";
		h +=
			"<div id='heatmap-span' style='height: 20px; color: #6a6666; margin-top: -30px; z-index: 1; font-style: italic; display: none'>Click on the heatmap to show the associated scatterplot</div>";
		h += "<div id='scatterplot' style='display: none;' class='col-md-0 col-sm-12 col-12 position-relative'>";
		h += `<input id="scatAxisToggle" type="checkbox" data-toggle="toggle" data-onlabel="log" data-offlabel="lin">`;
		h += `<button id='closeScat' type='button' class='btn btn-xs ${aeroval.settings.theme} btn-close position-absolute top-0 end-0' style='z-index: 10;' title='Close'><span aria-hidden='true' style='font-weight: normal; font-size: 16px;'></span></button>`;
		h += "<div id='scatt'></div>";
		h += '</div>';
		h += "<div id='hideElements' class='container'></div>";
		h += '</div>';
		h += '</div>';
		const navHeatmap = document.getElementById('nav-heatmap');
		if (navHeatmap) {
			navHeatmap.innerHTML = h;
		}

		// Initialize toggle
		const toggle = document.getElementById('scatAxisToggle') as HTMLInputElement;
		// initialize bootstrap toggles
		document.querySelectorAll("[data-toggle='toggle']").forEach((element) => {
			(element as any).bootstrapToggle({
				onstyle: aeroval.settings.theme,
				offstyle: aeroval.settings.theme,
				size: 'mini',
			} as BootstrapToggleOptions);
		});

		// Set up function
		toggle.addEventListener('change', function () {
			// If switch off
			const axisType = this.checked ? 'logarithmic' : 'linear'
			update('axisType', axisType);
		});

		// Set up close button action
		const closeButton = document.getElementById('closeScat');
		if (closeButton) {
			closeButton.addEventListener('click', function () {
				hideScat();
			});
		}
	} else if (aeroval.tab == 'taylor') {
		// first, empty the other tabs
		for (const tab of ['nav-heatmap', 'nav-timeseries', 'nav-target', 'nav-median']) {
			const tabElement = document.getElementById(tab);
			if (tabElement) {
				tabElement.innerHTML = '';
			}
		}

		// then, creates the divs
		var h = "<div id='menu'></div>";
		h += "<div id='main-content'>";
		h += "<div class='row h-100' style='width: 100%; margin: 10px 0px; padding: 0px;'>";
		h += "<div id='tlrdgrm' class='w-100 h-100'></div>";
		h += '</div>';
		h += '</div>';
		const navTaylor = document.getElementById('nav-taylor');
		if (navTaylor) {
			navTaylor.innerHTML = h;
		}
	} else if (aeroval.tab == 'timeseries') {
		// first, empty the other tabs
		for (const tab of ['nav-heatmap', 'nav-taylor', 'nav-target', 'nav-median']) {
			const tabElement = document.getElementById(tab);
			if (tabElement) {
				tabElement.innerHTML = '';
			}
		}

		//then, creates the divs
		var h = "<div id='menu'></div>";
		h += "<div id='main-content'>";
		h += "<div class='row h-100' style='width: 100%; margin: 10px 0px; padding: 0px;'>";
		h += "<div id='overall-ts' class='w-100 h-100' style='min-height: 500px !important;'></div>";
		h += '</div>';
		h += '</div>';

		const navTimeSeries = document.getElementById('nav-timeseries');
		if (navTimeSeries) {
			navTimeSeries.innerHTML = h;
		}
	} else if (aeroval.tab == 'target') {
		// first, empty the other tabs
		for (const tab of ['nav-heatmap', 'nav-taylor', 'nav-timseries', 'nav-median']) {
			const tabElement = document.getElementById(tab);
			if (tabElement) {
				tabElement.innerHTML = '';
			}
		}

		var h = `<div id='menu'></div>
		<div id='main-content'>
			<div id='target'></div>
		</div>`;

		const navTarget = document.getElementById('nav-target');
		if (navTarget) {
			navTarget.innerHTML = h;
		}
		initTargets('target', true, true);
	} else if (aeroval.tab == 'median') {
		// first, empty the other tabs
		for (const tab of ['nav-heatmap', 'nav-taylor', 'nav-timeseries', 'nav-target']) {
			const tabElement = document.getElementById(tab);
			if (tabElement) {
				tabElement.innerHTML = '';
			}
		}

		// then, creates the divs
		var h = "<div id='menu'></div>";
		h += "<div id='main-content'>";
		h += "<div class='row h-100' style='width: 100%; margin: 10px 0px; padding: 0px;'>";
		h += "<div id='frcst-ts' class='w-100 h-100' style='min-height: 500px !important;'></div>";
		h += '</div>';
		h += '</div>';

		const navMedian = document.getElementById('nav-median');
		if (navMedian) {
			navMedian.innerHTML = h;
		}
	}
	// show description if cookie not set to true
	chartDescription(aeroval.tab);
}

function chartDescription(which: string): void {
	const desc = {
		taylor:
			'The <a href="https://doi.org/10.1029/2000JD900719">Taylor diagram</a> is a 2D representation of the model performances using polar coordinates. The radius represents the normalized standard deviation while the angle indicates the correlation. The closer a model is to the Reference point, the higher its performance is.',
		median:
			'This chart allows to investigate how well a model performs as function of forecast/analysis hour. For example, for the <strong>forecasts</strong>, Hour=48 shows the performance of the model to forecast the selected variable 2 days in the future. For the <strong>analyses</strong>, the performance is shown as a function of the analysis hour, i.e. the 24 hours of the day before.',
		target:
			'The <strong>target plots</strong> have originally been designed within the <a href="https://fairmode.jrc.ec.europa.eu/" class="alert-link">FAIRMODE</a> project for quickly identifying if a model satisfies predefined statistics criteria based on comparisons with observations. This includes a circular target (defined using observations uncertainties) as well as multiple bar targets investigating time and space statistics. More information can be found in the FAIRMODE <a href="https://fairmode.jrc.ec.europa.eu/document/fairmode/WG1/MQO_GuidanceV3.2_online.pdf" class="alert-link">Guidance Document.</a> Please note that these plots are based on the <strong>assessment</strong> metrics of FAIRMODE.',
	} as any;

	if (which in desc && getCookie(`close-${which}-alert`) !== 'true') {
		var h = '<div class="alert alert-dismissible fade show my-2" role="alert">';
		h += '<i class="fas fa-info-circle" style="margin: 0px 8px 0px 0px; font-size: large;"></i>';
		h += desc[which];
		h += `<button id="close-${which}-alert" type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>`;
		h += '</div>';
		const mainContent = document.getElementById('main-content');
		if (mainContent) {
			mainContent.insertAdjacentHTML('afterbegin', h);
		}

		// set up button action
		const closeButton = document.getElementById(`close-${which}-alert`);
		if (closeButton) {
			closeButton.addEventListener('click', function () {
				setCookie(this.id, 'true', 14);
			});
		}
	}
}

async function updateTimeSeries(): Promise<void> {
	const chart = utils.getChartById('overall-ts');
	if (!chart) return;

	if (aeroval.groupBy == 'None') {
		chart.xAxis[0].update({
			min: aeroval.dateMin?.valueOf(),
			max: aeroval.dateMax?.valueOf(),
		});
		chart.setTitle({ text: `${aeroval.parameter.name} - ${aeroval.region} - ${aeroval.time}` });
	} else {
		const region = aeroval.region as string;
		const statsTsData = await getStatisticsTimeSeriesData(aeroval.project, aeroval.experiment.name, region, aeroval.observation, aeroval.parameter.dir, aeroval.layer)
		if (statsTsData) plotStatisticsTimeSeries(statsTsData, aeroval.parameter.dir, aeroval.observation, aeroval.layer, aeroval.statistic.dir, aeroval.groupBy, 'overall-ts');
	}
}

